var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33 0H14.669C18.07 0 19.99 1.929 20 5.33V14.67C20 18.07 18.07 20 14.669 20H5.33C1.929 20 0 18.07 0 14.67V5.33C0 1.929 1.929 0 5.33 0ZM10.0489 15.8614C10.4799 15.8614 10.8389 15.5414 10.8789 15.1114V4.92141C10.9189 4.61141 10.7699 4.30041 10.4999 4.13141C10.2189 3.96141 9.87891 3.96141 9.60991 4.13141C9.33891 4.30041 9.18991 4.61141 9.21891 4.92141V15.1114C9.26991 15.5414 9.62891 15.8614 10.0489 15.8614ZM14.6499 15.8616C15.0699 15.8616 15.4289 15.5416 15.4799 15.1116V11.8316C15.5089 11.5106 15.3599 11.2116 15.0889 11.0416C14.8199 10.8716 14.4799 10.8716 14.1999 11.0416C13.9289 11.2116 13.7799 11.5106 13.8199 11.8316V15.1116C13.8599 15.5416 14.2189 15.8616 14.6499 15.8616ZM6.21896 15.1087C6.17896 15.5387 5.81996 15.8588 5.38896 15.8588C4.95896 15.8588 4.59896 15.5387 4.55996 15.1087V8.19875C4.52996 7.88775 4.67896 7.57875 4.94996 7.40875C5.21896 7.23875 5.55996 7.23875 5.82996 7.40875C6.09896 7.57875 6.24996 7.88775 6.21896 8.19875V15.1087Z",
    fill: "#005CEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.0f974b4eb5422ad0267d04b64e739642.svg";
export { ForwardRef as ReactComponent };